module.exports = __webpack_public_path__ + "img/bannerMobile-01.75963aff.png";